// 登录密码模态框
const LoginPassModal = () => import('@/views/personal/Modal/LoginPassModal')
// 资金密码模态框
const FundPassModal = () => import('@/views/personal/Modal/FundPassModal')
// 邮箱模态框
const EmailModal = () => import('@/views/personal/Modal/EmailModal')
// 手机验证模态框
const PhoneModal = () => import('@/views/personal/Modal/PhoneModal')
// 修改手机验证模态框
const ModifyPhoneModal = () => import('@/views/personal/Modal/ModifyPhoneModal')
// 切换'(打开/关闭)手机安全验证
const SwitchPhoneModal = () => import('@/views/personal/Modal/SwitchPhoneModal')
// 谷歌验证模态框
const GoogleVerifyModal = () => import('@/views/personal/Modal/GoogleVerifyModal')

/** 验证模态框 - 开始 */

const LoginPassVerify = () => import('@/views/personal/Modal/LoginPassVerifyModal')
const FundPassVerify = () => import('@/views/personal/Modal/FundPassVerifyModal')
const openOrCloseVerify = () => import('@/views/personal/Modal/OpenOrCloseVerifyModal')

/** 打开手机 谷歌 邮箱 验证框 */
const OpenPhoneVerify = () => import('@/views/personal/Modal/OpenPhoneVerifyModal')
const OpenEmailVerify = () => import('@/views/personal/Modal/OpenEmailVerifyModal')
const OpenGoogleVerify = () => import('@/views/personal/Modal/OpenGoogleVerifyModal')
const MentionMoneyVerifyModal = () => import('@/views/personal/Modal/MentionMoneyVerifyModal')
/** 验证模态框 - 结束 */

export default {
  loginPass: LoginPassModal,
  email: EmailModal,
  fundPass: FundPassModal,
  phone: PhoneModal,
  modifyPhone: ModifyPhoneModal,
  switchPhone: SwitchPhoneModal,
  googleVerify: GoogleVerifyModal,
  loginPassVerify: LoginPassVerify, // 登录验证模态框
  fundPassVerify: FundPassVerify, // 资金密码验证模态框
  openOrCloseVerify: openOrCloseVerify, // 打开或关闭安全验证
  openPhoneVerify: OpenPhoneVerify, // 开启手机验证
  openEmailVerify: OpenEmailVerify, // 开启邮箱验证
  openGoogleVerify: OpenGoogleVerify,
  mentionMoneyVerifyModal: MentionMoneyVerifyModal // 提币校验
}
